import { WorkatoConnectionProvider } from "@intentsify/types";

export const getWorkatoProviderLogoUrl = (
  workatoProvider: WorkatoConnectionProvider
) =>
  `https://intentsify-email-assets.s3.us-west-1.amazonaws.com/${workatoProvider.toLowerCase()}.svg`;
